import { Image } from "~/components/Image";
import React, { useRef } from "react";
import { ArchivePageLink } from "~/components/links/ArchivePageLink";
import { Archive } from "~/generated/rtk-query/nowdo-live-api.generated";
import css from "./index.module.scss";
import { useClientSize } from "~/hooks/useClientSize";

const aspectRatio = 206 / 355;

export const BigArchiveCard: React.FC<{ archive: Archive }> = ({ archive }) => {
  const cardInnerRef = useRef<HTMLDivElement>(null);
  const cardInnerSize = useClientSize(cardInnerRef.current);

  const height = cardInnerSize.screenWidth ? cardInnerSize.screenWidth * aspectRatio : 206;

  return (
    <article>
      <ArchivePageLink
        archiveId={archive.id}
        aProps={{
          className: css.card,
        }}
      >
        <div
          style={{
            height,
          }}
          ref={cardInnerRef}
          className={css.card__inner}
        >
          <Image
            className={css.card__thumbnail}
            src={archive.imageUrl}
            width={(355 * height) / 206}
            height={height}
            alt=""
          />
        </div>
        <div>
          <div className={css.card__info}>
            <div className={css.card__count}>
              <p>{archive.watchCount}人が視聴</p>
            </div>

            <p className={css.card__ownerName}>{archive.owners[0].name}</p>
          </div>
          <p className={css.card__name}>{archive.title}</p>
          {archive.description && (
            <div className={css.card__description}>
              <p>{archive.description}</p>
            </div>
          )}
        </div>
      </ArchivePageLink>
    </article>
  );
};
